import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserProfile } from "../../models/user-profile/user-profile.model";

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {

    constructor(private http: HttpClient) {}

    getUserProfiles(): Observable<{ userProfiles: UserProfile[] }> {
        const url = `${environment.user.root}`;
        return this.http.get<{ userProfiles: UserProfile[] }>(url, { withCredentials: true });
    }

    getProfile(): Observable<UserProfile> {
        const url = `${environment.user.root}/me`;
        return this.http.get<UserProfile>(url, { withCredentials: true });
    }

    getProfileByGuid(userProfileGuid: string): Observable<UserProfile> {
        const url = `${environment.user.root}/${userProfileGuid}`;
        return this.http.get<UserProfile>(url, { withCredentials: true });
    }

    updateProfile(userProfileGuid: string, payload: Partial<UserProfile>): Observable<UserProfile> {
        const url = `${environment.user.root}/${userProfileGuid}`;
        return this.http.put<UserProfile>(url, payload, { withCredentials: true });
    }

    changePassword(userProfileGuid: string, payload: { currentPassword: string; newPassword: string }): Observable<void> {
        const url = `${environment.user.root}/${userProfileGuid}/change-password`;
        return this.http.post<void>(url, payload, { withCredentials: true });
    }

    resetPassword(employeeGuid: string): Observable<void> {
        const url = `${environment.user.root}/by-employee/${employeeGuid}/reset-password`;
        return this.http.post<void>(url, null, { withCredentials: true });
    }
}
